<template>
  <rest-list-action
    icon="el-icon-tickets"
    :title="title ? title : $t('RestList_Action_View')"
    :route="route"
    :data-qa="dataQa"
  />
</template>

<script>
import RestListAction from '@/common/components/rest/RestListAction'

export default {
  name: 'RestListActionView',

  components: { RestListAction },

  props: {
    route: {
      type: [Object, String],
      required: true
    },
    title: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      required: false,
      default: 'view-action-button'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionView.vue